module.exports = __webpack_public_path__ + "static/media/card.cac076cd.svg";